import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import RoleProfileEditor from "@/components/profile/RoleProfileEditor";

export default function ConsultantProfile() {
  const navigate = useNavigate();

  return (
    <>
      <Button
        variant="ghost"
        onClick={() => navigate("/dashboard/consultant")}
        className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Dashboard
      </Button>
      <div className="container mx-auto p-6 max-w-5xl">
        <RoleProfileEditor role="consultant" />
      </div>
    </>
  );
}
